import { render, staticRenderFns } from "./TypeButtonList.vue?vue&type=template&id=f9d3597a"
import script from "./TypeButtonList.vue?vue&type=script&lang=js"
export * from "./TypeButtonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports